import React, { useState } from "react"
import PropTypes from "prop-types"
import { graphql } from "gatsby"
import { RichText } from "prismic-reactjs"
import { css, mq } from "@emotion/core"
import { colors } from "../styles/styles"
import SwiperCore, { Navigation, Thumbs } from "swiper"
import { Swiper, SwiperSlide } from "swiper/react"
import Image from "../components/image"
import SEO from "../components/SEO"
import Slider from "../components/slider"
import linkResolver from "../utils/linkResolver"
import LocalizedLink from "../components/localizedLink"
import Contact from "../components/contact"
import Feedback from "../components/feedback"
// import { redirectToUserLanguage } from "../utils/utils"
import { isExternalLink, isDocumentLink } from "../utils/utils"

SwiperCore.use([Navigation, Thumbs])

const IndexPage = ({ data, pageContext: { locale }, location }) => {
  const IndexPageData = data.prismic.homepage
  const IndexFieldsData = data.prismic.allFieldspages
  const IndexClientsData = data.prismic.allClientspages
  const [thumbsSwiper, setThumbsSwiper] = useState(null)
  const [selectedBenefit, setSelectedBenefit] = useState(
    IndexPageData.benefits_list[0]
  )
  const [dotSelected, setDotSelected] = useState(null)

  let sliderFields = []
  let sliderShop = []
  // get and set the sectors/fields to be displayed on the homepage, in the correct order
  let fieldDisplayedOnHome = IndexFieldsData.edges[0].node.body.filter(
    displayed => displayed.primary.field_isdisplayedonhome > 0
  )
  fieldDisplayedOnHome = fieldDisplayedOnHome.sort(
    (a, b) =>
      a.primary.field_isdisplayedonhome > b.primary.field_isdisplayedonhome
  )
  fieldDisplayedOnHome.forEach(field => {
    const slide = {
      id: field.primary.field_id,
      name: RichText.asText(field.primary.field_title),
      sharp: field.primary.field_imageSharp,
      image: field.primary.field_image,
    }
    sliderFields.push(slide)
  })

  IndexPageData.shop_products.forEach(product => {
    const slide = {
      id: product.shop_products_id,
      name: product.shop_products_name,
      sharp: product.shop_products_imageSharp,
      image: product.shop_products_image,
      link: product.shop_product_link,
    }
    sliderShop.push(slide)
  })

  // redirectToUserLanguage()

  return (
    <>
      <SEO
        title={IndexPageData.meta_title}
        desc={IndexPageData.meta_description}
        metadata={data.site.siteMetadata}
        locale={locale}
        pathname={location.pathname}
      />

      <div className="container-fluid" css={homeCss}>
        <section className="section is-medium is-themeGradientH">
          <div className="columns is-multiline is-centered">
            <div className="column is-6" style={{ marginTop: "50px" }}>
              <h1 className="title  is-size-1-desktop is-size-3-mobile has-text-centered has-text-weight-normal">
                {RichText.asText(IndexPageData.title)}
              </h1>
              <h2 className="title is-5 has-text-centered has-text-weight-extralight">
                {RichText.asText(IndexPageData.subtitle)}
              </h2>
              <div className="has-text-centered">
                {/* <RichText render={IndexPageData.content} /> */}
              </div>
              <br />
              {IndexPageData.call_to_action.map(action => {
                return (
                  <div
                    key={action.id}
                    className="is-centered has-text-centered"
                  >
                    {action.call_to_action_link &&
                      isExternalLink(action.call_to_action_link) && (
                        <a
                          href={action.call_to_action_link.url}
                          className="button is-rounded button__primary has-text-white"
                          target={action.call_to_action_link.target}
                          rel="noopener noreferrer nofollow"
                        >
                          {action.call_to_action_text}
                        </a>
                      )}
                    {action.call_to_action_link &&
                      isDocumentLink(action.call_to_action_link) && (
                        <LocalizedLink
                          to={action.call_to_action_link._meta.uid}
                          className="button is-rounded button__primary has-text-white"
                        >
                          {action.call_to_action_text}
                        </LocalizedLink>
                      )}

                    <div className="is-size-2">
                      <i className="icon icon-play_btn"></i>
                    </div>
                  </div>
                )
              })}
            </div>
          </div>
        </section>

        <div className="columns is-centered">
          <div className="column main__image">
            {IndexPageData.main_image && (
              <Image
                sharp={IndexPageData.main_imageSharp}
                image={IndexPageData.main_image}
              />
            )}
          </div>
        </div>

        <section className="section">
          <div className="container">
            <div className="columns">
              <div className="column is-4">
                {IndexPageData.app_image && (
                  <Image
                    sharp={IndexPageData.app_imageSharp}
                    image={IndexPageData.app_image}
                  />
                )}
              </div>
              <div className="column is-4">
                <h3 className="title is-4 is-uppercase has-text-centered has-text-weight-semibold">
                  {RichText.asText(IndexPageData.app_title)}
                </h3>
                <p className="has-text-centered">
                  {RichText.asText(IndexPageData.app_subtitle)}
                </p>
                <ul className="is-centered has-text-centered">
                  {IndexPageData.app_store.map(store => {
                    return (
                      <li key={store.store_name} className="badges__app">
                        <a href={store.store_link.url}>
                          {store.store_image && (
                            <figure className="image">
                              <Image
                                sharp={store.store_imageSharp}
                                image={store.store_image}
                              />
                            </figure>
                          )}
                        </a>
                      </li>
                    )
                  })}
                </ul>
              </div>
              <div className="column is-4">
                {IndexPageData.app_image1 && (
                  <Image
                    sharp={IndexPageData.app_image1Sharp}
                    image={IndexPageData.app_image1}
                  />
                )}
              </div>
            </div>
          </div>
        </section>

        <section className="section is-theme2">
          <div className="container">
            <div className="columns is-centered">
              <div className="column is-6">
                <h3 className="title is-3 has-text-centered has-text-weight-semibold">
                  {RichText.asText(IndexPageData.benefits_title)}
                </h3>
                <p className="has-text-centered">
                  {RichText.asText(IndexPageData.benefits_subtitle)}
                </p>
              </div>
            </div>
            <div className="columns is-centered is-vcentered">
              <div className="column is-5-desktop is-4-tablet is-12-mobile">
                {selectedBenefit.benefits_item_image && (
                  <Image
                    sharp={selectedBenefit.benefits_item_imageSharp}
                    image={selectedBenefit.benefits_item_image}
                  />
                )}
              </div>
              <div className="column is-7-desktop is-8-tablet is-12-mobile">
                {IndexPageData.benefits_list.map(benefit => {
                  return (
                    <button
                      key={benefit.benefits_id}
                      onClick={() => setSelectedBenefit(benefit)}
                      className="button is-fullwidth benefits__button"
                    >
                      <span
                        className={
                          "icon icon-" + benefit.benefits_id.toLowerCase()
                        }
                      />
                      {benefit.benefits_item_name}
                    </button>
                  )
                })}
              </div>
            </div>
          </div>
        </section>

        <section
          className="section"
          css={{ paddingLeft: "0", paddingRight: "0" }}
        >
          <div css={slideFeatureCss}>
            <Swiper
              breakpoints={{
                640: {
                  slidesPerView: 1,
                  spaceBetween: 10,
                },
                768: {
                  slidesPerView: 2,
                  spaceBetween: 20,
                },
                1024: {
                  slidesPerView: 3,
                  spaceBetween: 30,
                },
              }}
              onSwiper={setThumbsSwiper}
              navigation={{
                nextEl: ".swiper-button-next",
                prevEl: ".swiper-button-prev",
              }}
              className="swiper-features"
            >
              {IndexPageData.features.map((feature, i) => {
                return (
                  <SwiperSlide key={i}>
                    <div key={i} className="column is-2">
                      {feature.primary.feature_image_icon && (
                        <Image
                          sharp={feature.primary.feature_image_iconSharp}
                          image={feature.primary.feature_image_icon}
                        />
                      )}
                      {RichText.asText(feature.primary.feature_title)}
                    </div>
                  </SwiperSlide>
                )
              })}
              <div
                role="button"
                name="Previous slide"
                className="swiper-button-prev btn-shadow"
              ></div>
              <div
                role="button"
                name="Next slide"
                className="swiper-button-next btn-shadow"
              ></div>
            </Swiper>
            <div
              className="columns is-centered is-multiline slide__features-screenshot"
              css={{
                backgroundImage: `url(../images/slider__features-bg.png)`,
                backgroundRepeat: "no-repeat",
                backgroundPosition: "top center",
                marginTop: "40px",
                paddingLeft: "1.5rem",
                paddingRight: "1.5rem",
              }}
            >
              <Swiper
                thumbs={{ swiper: thumbsSwiper }}
                navigation={{
                  nextEl: ".swiper-button-next",
                  prevEl: ".swiper-button-prev",
                }}
              >
                {IndexPageData.features.map((feature, i) => (
                  <SwiperSlide key={i}>
                    <div
                      className="column is-5 has-text-centered has-text-white"
                      css={{ zIndex: 1000, paddingTop: "50px" }}
                    >
                      {RichText.render(
                        feature.primary.feature_description,
                        linkResolver
                      )}
                    </div>
                    <div
                      className="column is-8 is-12-mobile"
                      css={{ position: "relative" }}
                    >
                      <div className="interactiveDots">
                        {feature.fields.map(dot => (
                          <>
                            {dot.id !== null && (
                              <div
                                key={dot.id}
                                className="dot icon-target is-size-3-desktop is-size-5-touch"
                                css={{ top: `${dot.y}%`, left: `${dot.x}%` }}
                                onClick={() => setDotSelected(dot.id)}
                              />
                            )}
                            {dot.id !== null && dotSelected === dot.id && (
                              <div
                                className="dotDescription notification"
                                css={{ bottom: `${dot.pop_y}%` }}
                              >
                                <button
                                  class="delete"
                                  onClick={() => setDotSelected(false)}
                                />
                                {dot.feature_step_image && (
                                  <Image
                                    sharp={dot.feature_step_imageSharp}
                                    image={dot.feature_step_image}
                                  />
                                )}
                                {dot.feature_step_content &&
                                  RichText.render(
                                    dot.feature_step_content,
                                    linkResolver
                                  )}
                              </div>
                            )}
                          </>
                        ))}
                      </div>
                      {feature.primary.feature_image_main && (
                        <div onClick={() => setDotSelected(false)}>
                          <Image
                            sharp={feature.primary.feature_image_mainSharp}
                            image={feature.primary.feature_image_main}
                          />
                        </div>
                      )}
                    </div>
                  </SwiperSlide>
                ))}
              </Swiper>
            </div>
          </div>
        </section>

        <section className="section">
          <div className="container">
            <div className="columns is-centered">
              <div className="column is-10">
                {IndexPageData.overview_image && (
                  <Image
                    sharp={IndexPageData.overview_imageSharp}
                    image={IndexPageData.overview_image}
                  />
                )}
              </div>
            </div>
          </div>
        </section>

        <section className="section is-theme2">
          <div className="container">
            <div className="columns is-centered">
              <div className="column is-6">
                <h3 className="title is-3 has-text-centered has-text-weight-semibold">
                  {RichText.asText(IndexPageData.fields_title)}
                </h3>
                <p className="has-text-centered">
                  {IndexPageData.fields_subtitle &&
                    RichText.asText(IndexPageData.fields_subtitle)}
                </p>
              </div>
            </div>
            <Slider
              className="swiper-fields"
              slidesList={sliderFields}
              sliderId="fields"
            />
            <div className="has-text-centered">
              {IndexPageData.fields_call_to_actions.map((action, i) => {
                return (
                  <LocalizedLink
                    key={i}
                    to={action.fields_call_to_action_link._meta.uid}
                    className="button is-rounded button__primary has-text-white"
                  >
                    {action.fields_call_to_action_name}
                    <span className="icon-arrow_right pl-2"></span>
                  </LocalizedLink>
                )
              })}
            </div>
          </div>
        </section>

        <section className="section is-themeGradientV">
          <h3 className="title is-5 has-text-centered is-uppercase">
            {RichText.asText(IndexPageData.shop_title)}
          </h3>
          <Slider
            className="swiper-shop"
            slidesList={sliderShop}
            layout="titleFirst"
            sliderId="shop"
          />
          <div className="has-text-centered">
            {IndexPageData.shop_call_to_actions.map((action, i) => {
              if (
                action.shop_call_to_action_link._linkType === "Link.document"
              ) {
                return (
                  <LocalizedLink
                    key={i}
                    to={action.shop_call_to_action_link._meta.uid}
                    className="button is-rounded button__primary has-text-white"
                  >
                    {action.shop_call_to_action_name}
                  </LocalizedLink>
                )
              }
              if (action.shop_call_to_action_link._linkType === "Link.web") {
                return (
                  <a
                    key={i}
                    href={action.shop_call_to_action_link.url}
                    className="button is-rounded button__primary has-text-white is-uppercase"
                  >
                    {action.shop_call_to_action_name}
                    <span className="icon-arrow_right pl-2"></span>
                  </a>
                )
              }
              return true
            })}
          </div>
        </section>

        <Feedback feedback={data.prismic.allFeedbackcomponents.edges[0].node} />

        <section className="section is-medium">
          <Contact contactData={data.prismic.allContactforms} />
        </section>
      </div>
    </>
  )
}

export default IndexPage

IndexPage.propTypes = {
  data: PropTypes.shape({
    prismic: PropTypes.object.isRequired,
  }).isRequired,
}

export const indexQuery = graphql`
  query IndexQuery($locale: String!) {
    prismic {
      homepage(lang: $locale, uid: "homepage") {
        meta_title
        meta_description
        title
        subtitle
        call_to_action {
          id
          call_to_action_text
          call_to_action_link {
            _linkType
            ... on PRISMIC__Document {
              _meta {
                uid
              }
            }
            ... on PRISMIC__ExternalLink {
              url
              target
            }
          }
        }
        main_image
        main_imageSharp {
          extension
          childImageSharp {
            fluid {
              ...GatsbyImageSharpFluid_tracedSVG
            }
          }
        }

        app_title
        app_subtitle
        app_store {
          store_name
          store_image
          store_imageSharp {
            extension
            childImageSharp {
              fluid {
                ...GatsbyImageSharpFluid_tracedSVG
              }
            }
          }
          store_link {
            __typename
            ... on PRISMIC__ExternalLink {
              url
            }
          }
        }
        app_image
        app_imageSharp {
          extension
          childImageSharp {
            fluid {
              ...GatsbyImageSharpFluid_tracedSVG
            }
          }
        }
        app_image1
        app_image1Sharp {
          extension
          childImageSharp {
            fluid {
              ...GatsbyImageSharpFluid_tracedSVG
            }
          }
        }
        benefits_title
        benefits_subtitle
        benefits_list {
          benefits_id
          benefits_item_name
          benefits_item_image
          benefits_item_imageSharp {
            extension
            childImageSharp {
              fluid {
                ...GatsbyImageSharpFluid_tracedSVG
              }
            }
          }
        }

        features {
          ... on PRISMIC_HomepageFeaturesFeature {
            primary {
              feature_title
              feature_description
              feature_image_icon
              feature_image_iconSharp {
                extension
                childImageSharp {
                  fluid {
                    ...GatsbyImageSharpFluid_tracedSVG
                  }
                }
              }
              feature_image_main
              feature_image_mainSharp {
                extension
                childImageSharp {
                  fluid {
                    ...GatsbyImageSharpFluid_tracedSVG
                  }
                }
              }
            }
            fields {
              id
              feature_step_content
              x
              y
              pop_y
              feature_step_image
              feature_step_imageSharp {
                extension
                childImageSharp {
                  fluid {
                    ...GatsbyImageSharpFluid_tracedSVG
                  }
                }
              }
            }
          }
        }

        overview_image
        overview_imageSharp {
          extension
          childImageSharp {
            fluid {
              ...GatsbyImageSharpFluid_tracedSVG
            }
          }
        }

        fields_title
        fields_subtitle
        fields_call_to_actions {
          fields_call_to_action_name
          fields_call_to_action_link {
            __typename
            ... on PRISMIC__Document {
              _meta {
                uid
              }
            }
          }
        }

        shop_title
        shop_call_to_actions {
          shop_call_to_action_name
          shop_call_to_action_link {
            _linkType
            ... on PRISMIC__Document {
              _meta {
                uid
              }
            }
            ... on PRISMIC__ExternalLink {
              url
            }
          }
        }
        shop_products {
          shop_products_id
          shop_products_name
          shop_product_link {
            ... on PRISMIC__ExternalLink {
              url
            }
          }
          shop_products_image
          shop_products_imageSharp {
            extension
            childImageSharp {
              fluid {
                ...GatsbyImageSharpFluid_tracedSVG
              }
            }
          }
        }

        contact_title
        contact_subtitle
        contact_fields {
          contact_fields_id
          contact_fields_title
        }
        contact_checkbox
        contact_button {
          contact_button_id
          contact_button_title
        }
        contact_call_to_actions {
          contact_call_to_action_id
          contact_call_to_action_text
        }
        contact_image
        contact_imageSharp {
          extension
          childImageSharp {
            fluid {
              ...GatsbyImageSharpFluid_tracedSVG
            }
          }
        }
      }

      allFieldspages(lang: $locale) {
        edges {
          node {
            _meta {
              uid
              type
            }
            ...Sectors
          }
        }
      }

      allClientspages(lang: $locale) {
        edges {
          node {
            _meta {
              uid
              lang
            }
            feedbacks {
              feedback_id
              feedback_title
              feedback_content
              feedback_client_name
              feedback_client_rank
              feedback_image
            }
          }
        }
      }
      ...Feedback
      ...Contact
    }
    site {
      ...SiteInformation
    }
  }
`

const slideFeatureCss = css`
  .section {
    padding: 3rem 0 !important;
  }

  .swiper-slide {
    display: flex;
    flex-direction: column;
    align-items: center;
    width: auto;
  }

  .swiper-container-thumbs {
    .swiper-slide {
      cursor: pointer;
      border-right: 1px solid rgba(90, 104, 127, 0.14);
    }
    &:last-child {
      border-right: 0px solid black;
    }
  }

  .swiper-slide-thumb-active {
    background: linear-gradient(
      180deg,
      rgba(255, 255, 255, 0.33) 0%,
      rgba(217, 223, 230, 0.33) 50%,
      rgba(255, 255, 255, 0.33) 100%
    );
  }

  .slide__features-screenshot {
    background-size: contain;
  }

  @media (max-width: 768px) {
    .slide__features-screenshot {
      background-size: cover;
    }
  }
`

const homeCss = css`
  .main__image {
    .gatsby-image-wrapper {
      text-align: center;
    }
  }

  .badges__app {
    margin-top: 25px;
    .gatsby-image-wrapper {
      max-width: 180px;
      margin: 0 auto;
    }
  }

  .benefits__button {
    justify-content: left;
    border: 0;
    background-color: #c1c7e7;
    color: #3364c6;

    span {
      color: ${colors.blue};
      opacity: 34%;
      font-size: 25px;
      padding-left: 30px;
      padding-right: 50px;
    }

    &:not(:last-child) {
      margin-bottom: 10px;
    }

    &:hover {
      box-shadow: 0 12px 15px 0 rgba(61, 101, 191, 0.31);
      background-color: ${colors.blue};
      color: #fff;

      span {
        color: #f7b500;
        opacity: 1;
      }
    }
  }

  .interactiveDots {
    display: flex;
    justify-content: center;
    .dot {
      position: absolute;
      z-index: 10;
      background-color: #fff;
      -webkit-box-shadow: 0px 2px 3px 0px rgba(255, 255, 255, 1);
      -moz-box-shadow: 0px 2px 3px 0px rgba(255, 255, 255, 1);
      box-shadow: 0px 2px 3px 0px rgba(255, 255, 255, 1);
      color: ${colors.orange};
      border-radius: 20px;
      cursor: pointer;
    }

    .dotDescription {
      background-color: ${colors.zircon};
      position: absolute;
      z-index: 1010;
      border-radius: 10px;
      width: 50%;
      height: 50%;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
      overflow: scroll;
      .gatsby-image-wrapper {
        max-width: 400px;
        margin: 0 auto;
      }
    }
  }

  @media (max-width: 767px) {
    .main__image {
      .gatsby-image-wrapper {
        margin-top: -100px;
        margin-bottom: -75px;
      }
    }

    .benefits__button {
      display: flex;
      flex-direction: column;
      height: auto;
      white-space: inherit;

      span {
        padding-left: 0;
        padding-right: 0;
      }
    }
  }

  @media (min-width: 768px) and (max-width: 1023px) {
    .main__image {
      .gatsby-image-wrapper {
        margin-top: -150px;
        margin-bottom: -125px;
      }
    }
  }

  @media (min-width: 1024px) {
    .main__image {
      .gatsby-image-wrapper {
        margin-top: -250px;
        margin-bottom: -150px;
      }
    }
  }
`
